import { z } from 'zod';
import { ErrorCode, IsoDateTime, Uuid } from './common.js';
/**
 * Live updates over Socket.IO (ADR 0007). Owner: task C1b (server) and C2 (portal client).
 *
 * - Path: `/api/socket.io`. Portal sockets authenticate with the session cookie (Origin checked);
 *   devices with `auth: { deviceToken }`.
 * - Clients never name rooms. They ask to subscribe to a channel for a site; the server checks the session or
 *   device, the channel's permission, the module flag and site access, then joins the room itself.
 * - Server -> client events: 'message' (RealtimeMessage) and 'control' (RealtimeControl).
 */
/** Channel keys come from module manifests (`realtimeChannels`). Phase 1: today (visits), kiosk and devices (kiosk-devices). */
export const RealtimeChannelKey = z.string().regex(/^[a-z][a-z0-9_-]{1,40}$/);
/** Client -> server 'subscribe' and 'unsubscribe'. Answered through the Socket.IO ack callback. */
export const RealtimeSubscribe = z.object({ channel: RealtimeChannelKey, siteId: Uuid });
export const RealtimeAck = z.union([
    z.object({ ok: z.literal(true) }),
    z.object({ ok: z.literal(false), error: ErrorCode }),
]);
/** Server -> client 'message'. `data` is typed by the channel's module (e.g. TodayLiveMessage, KioskLiveMessage). */
export const RealtimeMessage = z.object({
    channel: z.string(),
    siteId: Uuid.nullable(),
    data: z.unknown(),
    at: IsoDateTime,
});
/** Server -> client 'control': the session or device lost access; the socket is about to be closed. */
export const RealtimeControl = z.object({ type: z.enum(['reauth', 'revoked', 'module_disabled']) });
//# sourceMappingURL=realtime.js.map